<template>
        <div class="w3-container">
            <i class='fa fa-plus cursor-pointer w3-right flow-form-action active w3-ripple flow-blue-color flow-margin-right flow-margin-top fa-inverse flow-blue-color w3-ripple w3-xlarge'
               @click="openNewAppointmentCard"
                v-if="!showDelWarning && !openAddAppointment"
                :title="$t('addNewAppointment')">
            </i>

            <loading v-bind:dspin="displayLoading"></loading>

            <!--No appointment screen-->

            <div class="w3-content w3-center w3-margin-top w3-margin-bottom text-color font-weight-bold"
                 v-show="appointments.length === 0 && !openAddAppointment && !displayLoading">
                <h4>{{ hasNoAccessToAppointments ? $t("noAccessToAppointments") : $t("NO_APPOINTMENTS")}}</h4>
            </div>

            <table v-if="!showDelWarning && !openAddAppointment && !displayLoading && appointments.length > 0"  class="w3-table w3-bordered flow-table w3-animate-opacity">
                <thead class="">
                <th>{{ $t("time") }}</th>
                <th>{{ $t("status") }}</th>
                <th>{{ $t("appointment") }}</th>
                <!--<th>{{ $t("priority") }}</th>-->
                <th></th>
                <th></th>
                </thead>
                <tr v-for="appointment in appointments">
                    <td>{{appointment.time}}</td>
                    <td>
                        <patient-status :status="appointment.status" :showMarker="true"></patient-status>
                    </td>
                    <td>
                        <span v-if="appointment.physician">{{appointment.physician.name}} -</span>
                        <span class="consultation-group">{{appointment.consultationGroup.displayName}}</span>
                        <span>&nbsp;</span>
                        <span v-if="appointment.consultationRoom && isStatusInConsultation(appointment.status)"  class="consultation-room flow-btn w3-round-medium font-weight-bold">
                            {{ appointment.consultationRoom.displayName }}
                        </span>
                        <span>&nbsp;</span>
                        <i class="fa fa-undo-alt green-text" v-if="appointment.returningAppointmentId"></i>

                        <div v-if="relocationGroupIds.includes(appointment.consultationGroup.id)
                                    && !isStatusLeftConsultation(appointment.status)
                                    && !isStatusInConsultation(appointment.status)
                                    && !isStatusLeavingConsultation(appointment.status)
                                    && getRelocationPhysicians(appointment.physician? appointment.physician.id : '').length > 0">
                            <flow-select class="relocate-physicians"
                                         :items="getRelocationPhysicians(appointment.physician? appointment.physician.id : '')"
                                         :valueKey="'name'"
                                         :valueKeyIndex="'id'"
                                         :callback="selectPhysician">
                            </flow-select>
                            <i class="fa fa-check-circle cursor-pointer w3-xlarge flow-blue-color w3-margin-left w3-ripple"
                               :title="$t('relocate')"
                               @click="relocateAppointment(appointment)">
                            </i>
                        </div>

                    </td>
                    <td width="8%">
                        <appointment-priority
                                v-if="!isStatusLeftConsultation(appointment.status) && !isStatusInConsultation(appointment.status) && !isStatusLeavingConsultation(appointment.status)"
                                :appointmentId = "appointment.id"
                                :patientId = "patientId"
                                :appointmentHasPriority.sync = "appointment.hasPriority">
                        </appointment-priority>
                    </td>
                    <td v-if="isStatusLeftConsultation(appointment.status) || isStatusInConsultation(appointment.status) || isStatusLeavingConsultation(appointment.status)"></td>
                    <td v-else-if="checkForReturningAppointment(appointment)"></td>
                    <td v-else class="w-10pc">
                        <i class="cursor-pointer fa fa-trash  w3-text-red flow-form-action active w3-ripple w3-large" @click="showWarningSection(appointment)" :title="$t('deleteAppointment')"></i>
                    </td>
                </tr>
            </table>

            <!--Patient delete screens-->
            <div class="w3-content w3-center w3-margin-top w3-margin-bottom text-color" id="appointment-delete-section" v-show="showDelWarning">
                <h4 class="text-color"> {{$t("deleteAppointmentConfirm", {'physician' : (physicianName? physicianName: appointmentGroup), 'time' : appointmentTime})}} ? </h4>
                <div>
                    <button class="w3-bar-item w3-btn w3-ripple w3-round-medium flow-btn w3-margin flow-blue-bg-color" @click="deleteAppointment">
                        <i class="fa"><span><b class="w3-text-white">{{$t('yes')}}</b></span></i>
                    </button>
                    <button class="w3-bar-item w3-btn w3-ripple w3-round-medium flow-btn w3-margin flow-inactive-btn" @click="showDelWarning = false">
                        <i class="fa"><span><b>{{$t('no')}}</b></span></i>
                    </button>
                </div>
            </div>

            <!--Add appointment screen-->
            <new-appointment
                :openAddAppointment = "openAddAppointment"
                :patientId = "patientId"
                :lastAppointment = "lastAppointment"
                :isSideCard = "propsPatientId"
                :callback = "addAppointmentCardClosed">
            </new-appointment>
        </div>

</template>

<script>
    import PatientStatus from "../common/PatientStatus";
    import AppointmentPriority from "../patient/AppointmentPriority";
    import FlowSelect from "../common/FlowSelect";
    import NewAppointment from "../patient/NewAppointment";
    import Vue from 'vue';
    import Loading from "../common/Loading";
    import {EventBus} from "../../main";

    let frc = Vue.prototype.$frc;

    export default {
        name: "PatientAppointment",
        components: {PatientStatus, Loading, AppointmentPriority, NewAppointment, FlowSelect},
        props: ['propsPatientId'],
        data: function() {
            return{
                appointments: [],
                showDelWarning: false,
                physicianName: "",
                appointmentTime: "",
                displayLoading: true,
                patientId: '',
                appointmentId: '',
                openAddAppointment: false,
                relocationGroupIds: [],
                relocationPhysicians: [],
                relocationPhysicianId: '',
                hasNoAccessToAppointments: false,
                appointmentGroup: undefined
            }
        },
        computed: {
            lastAppointment () {
                return this.appointments[this.appointments.length - 1];
            }
        },
        watch: {
            propsPatientId: function () {
                this.showDelWarning = false;
                this.openAddAppointment = false;
                this.patientId = this.propsPatientId;
                if(this.propsPatientId !== undefined) {
                    this.getPatientAppointments(this.propsPatientId);
                }
            }
        },
        mounted() {
            var app = this;
            if(app.propsPatientId) {
                app.patientId = app.propsPatientId;
            }
            if(!app.propsPatientId){
                app.patientId = app.$route.params.id;
            }

            app.getRelocationSettings();
            app.getPatientAppointments(app.patientId);
            EventBus.$on("patientUpdated", this.getPatientAppointments);
        },
        beforeDestroy() {
            EventBus.$off("patientUpdated", this.getPatientAppointments);
        },
        methods: {
            getRelocationPhysicians(currentPhysicianId) {
                if(currentPhysicianId) {
                    return this.relocationPhysicians.filter(function(physician) {
                        return physician.id !== currentPhysicianId;
                    });
                } else {
                    return this.relocationPhysicians;
                }
            },
            selectPhysician(physician) {
                if (physician) {
                    this.relocationPhysicianId = physician.id;
                }
            },
            getRelocationSettings () {
                var app = this;
                app.relocationPhysicians = [];
                app.relocationGroupIds = [];
                frc.getAppointmentRelocationSettings().then(function (res) {
                    if (!res.data) {
                        return;
                    }
                    var physicians = res.data.physicians;

                    if (!physicians) {
                        return;
                    }
                    Vue.sortByKey(physicians, 'name');
                    app.relocationPhysicians = physicians;

                    var groups = res.data.consultationGroups;
                    if (groups) {
                        for (var i = 0; i < groups.length; i++) {
                            app.relocationGroupIds.push(groups[i].id);
                        }
                    }
                });
            },
            relocateAppointment (appointment) {
                var app = this;
                frc.relocateAppointment(app.patientId,{
                    appointmentId: appointment.id,
                    wardId: Vue.prototype.$currentWard.id,
                    physicianId: app.relocationPhysicianId,
                    consultationGroupId: appointment.consultationGroup.id,
                }).then(function (res) {
                    Vue.notifySuccess({title: app.$t('successfullyRelocatedAppointment')});
                    app.getPatientAppointments(app.patientId);
                    EventBus.$emit("Relocated", app.patientId);
                });
            },
            openNewAppointmentCard: function () {
                this.openAddAppointment = true;
            },
            addAppointmentCardClosed (appointmentAdded) {
                this.openAddAppointment = false;
                if (appointmentAdded) {
                    this.getPatientAppointments(this.patientId);
                }
            },
            checkForReturningAppointment: function (appointment) {
                for (var i = 0; i < this.appointments.length; i++) {
                    if (this.appointments[i].returningAppointmentId === appointment.id) {
                        return true;
                    }
                }
            },
            showWarningSection: function (appointment) {
                this.showDelWarning = true;
                if (appointment.physician) {
                    this.physicianName = appointment.physician.name;
                }
                this.appointmentTime = appointment.time;
                this.appointmentId = appointment.id;
                this.appointmentGroup = appointment.consultationGroup.displayName;
            },
            getPatientAppointments: function (patientId) {
                var app = this;
                app.displayLoading = true;
                app.hasNoAccessToAppointments = false;
                app.appointments = [];
                
                frc.getPatientAppointments(patientId).then(function(res) {
                    app.appointments = res.data;
                    app.displayLoading = false;
                }).catch(function(e) {
                    console.log(e);
                    app.displayLoading = false;
                    app.hasNoAccessToAppointments = e.restCodes && e.restCodes.includes("PHYSICIAN_HAS_NO_ACCESS");
                });
            },
            deleteAppointment: function () {
                var app = this;
                frc.deleteAppointment(app.patientId, app.appointmentId).then(function (res) {
                    app.showDelWarning = false;
                    app.getPatientAppointments(app.patientId);
                    Vue.notifySuccess({title : app.$t("appointmentDeleted")});
                    EventBus.$emit("appointmentDeleted", app.patientId);
                }).catch(function(e) {
                    app.showDelWarning = false
                });
            }
        }
    }
</script>